import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const VerticalAlign = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const HorizontalAlign = styled.div`
  display: flex;
  gap: 5px;
`;

export const HorizonAlign = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const TextLink = styled.span`
  cursor: pointer;
`;

export const BoxTag = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const MessageTooltip = styled.p`
  color: ${BaSeTheme.colors.institucionais.cinzaSebrae60};
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 12px;
  display: flex;
  align-items: center;
`;

export const PreviousEmailsWrapper = styled.div`
  padding: 10px 10px 10px 0px;
  width: 100%;
  display: flex;
  gap: 90px;
  justify-content: center;
`;

export const ColumnEmailDates = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FilterHeader = styled.div`
  padding-bottom: 16px;
  display: flex;
  justify-content: center;
`;

export const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  min-width: 200px;
  padding: 5px;
  overflow-y: auto;
  max-height: 300px;
`;

export const FilterBottom = styled.div`
  padding-top: 16px;
  display: flex;
  justify-content: center;
`;
